const infomational_banner_text_blocks = () => {

    $('.info-banner__button--single').on('click', function () {
        let index = $(this).data('index');
        let windowWidth = $(window).width();
        let headerOffsetHeight = 0;

        $('.info-banner__button').removeClass('info-banner__button--active');
        $(this).addClass('info-banner__button--active');
        $('.info-banner__select-wrapper').hide();
        $('.info-banner__blocks-wrapper')
            .removeClass('info-banner__blocks-wrapper--active')
            .hide();
        $('.info-banner__blocks-wrapper[data-index="' + index + '"]')
            .addClass('info-banner__blocks-wrapper--active')
            .fadeIn();

        if (windowWidth >= 834) {
            headerOffsetHeight = $('.header').height();
        }

        $('html, body').animate({
            scrollTop: $('.info-banner__blocks-wrapper--active').offset().top - headerOffsetHeight
        }, 500);
    });

    $('.info-banner__button--multiple').on('click', function () {
        let index = $(this).data('index');
        let windowWidth = $(window).width();
        let headerOffsetHeight = 0;
        $('.info-banner__select-wrapper').css('display', 'flex');
        $('.info-banner__button').removeClass('info-banner__button--active');
        $(this).addClass('info-banner__button--active');

        // $('.info-banner__blocks-wrapper--active .info-banner__block--multiple').hide();
        $('.info-banner__blocks-wrapper')
            .removeClass('info-banner__blocks-wrapper--active')
        // .hide();
        $('.info-banner__blocks-wrapper[data-index="' + index + '"]')
            .addClass('info-banner__blocks-wrapper--active')
        // .fadeIn();

        // $('.info-banner__blocks-wrapper--active .info-banner__block--multiple[data-index="0"]').show();

        $('.info-banner__blocks-wrapper').hide();

        $('.info-banner__select').empty();

        var underwriterOptions = window.underwriterOptions[index];

        // Check if the default option is already in the array
        var defaultOptionExists = underwriterOptions.some(option => option.id === 'default');

        // Add the default option only if it doesn't exist
        if (!defaultOptionExists) {
            var defaultOption = { id: 'default', text: 'Select your underwriter' };
            underwriterOptions.unshift(defaultOption);
        }

        // Reinitialize the select2 plugin
        $('.info-banner__select').select2({
            data: underwriterOptions,
            width: 'auto',
            selectionCssClass: 'info-banner__custom-select',
            dropdownCssClass: 'info-banner__custom-dropdown',
        }); 

        if (windowWidth >= 834) {
            headerOffsetHeight = $('.header').height();
        }

        // Animate scroll
        $('html, body').animate({
            scrollTop: $('.info-banner__custom-select').offset().top - (headerOffsetHeight + ($(window).width() <= 768 ? 200 : 120))
        }, 500);

    });

    $('.info-banner__select').on('change', function () {
        let index = $(this).val();

        $('.info-banner__block--multiple').hide();
        $('.info-banner__blocks-wrapper--active').fadeIn();
        $('.info-banner__blocks-wrapper--active .info-banner__block--multiple[data-index="' + index + '"]').fadeIn();
    });
}
export default infomational_banner_text_blocks;